export type GreetingPeriod = "morning" | "afternoon" | "evening";

export function greetingPeriod(hour: number): GreetingPeriod {
  if (hour < 12) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
}

export function greetingName(session: {
  displayName?: string | null;
  email?: string | null;
}): string {
  const named = (session.displayName || "").trim();
  if (named) return named;
  const email = (session.email || "").trim();
  if (!email) return "";
  return email.split("@")[0] || "";
}
